import axios from 'axios';
import {
  getAuthToken,
  clearAllItems,
  isAdminMode,
  getRegion
} from '../../utils/session-util';
import status from 'http-status';
import { regions } from '../../constants/region';

let US_BASE_URL = process.env.REACT_APP_API_LOCATION_US;
let CANADA_BASE_URL = process.env.REACT_APP_API_LOCATION_US;

const getApiUrl = () =>
  `${getRegion() === regions.CAN ? CANADA_BASE_URL : US_BASE_URL}/api/v2`;

const getPublicApiUrl = () => `${getApiUrl()}/public`;
const getUsApiUrl = () => `${US_BASE_URL}/api/v2`;

const handleErrorResponse = (error) => {
  if (!!error.response && error.response.status === status.FORBIDDEN) {
    clearAllItems();
    window.location.href = '/';
  }
  return Promise.reject(error);
};

const makeAuthedAxios = (isAdmin) => {
  const result = axios.create({
    headers: { Authorization: 'Bearer ' + getAuthToken(isAdmin) }
  });

  result.interceptors.response.use((response) => response, handleErrorResponse);

  return result;
};

let AXIOS_AUTHED = makeAuthedAxios(false);
let AXIOS_ADMIN_AUTHED = makeAuthedAxios(true);

const initializeAxios = (isAdmin) => {
  if (isAdmin) AXIOS_ADMIN_AUTHED = makeAuthedAxios(true);
  else AXIOS_AUTHED = makeAuthedAxios(false);
};

const getAxiosInstanceByLoginMode = () =>
  isAdminMode() ? AXIOS_ADMIN_AUTHED : AXIOS_AUTHED;

const AXIOS_UNAUTHED = axios.create();

const DEFAULT_PAGEABLE = {
  page: {
    size: null,
    number: null
  },
  sortBy: {
    name: null,
    direction: null
  }
};

const MAX_PAGE_SIZE = 1000;

export {
  getApiUrl,
  getPublicApiUrl,
  AXIOS_AUTHED,
  AXIOS_ADMIN_AUTHED,
  AXIOS_UNAUTHED,
  DEFAULT_PAGEABLE,
  MAX_PAGE_SIZE,
  initializeAxios,
  getAxiosInstanceByLoginMode,
  getUsApiUrl
};
